import http from "../../http-common";

class RecognitionManager {
    /**
     * Lấy danh sách người dùng có trên thiết bị nhưng chưa có trên DB
     * @param idDevice
     */
    getUserFromDevice(idDevice) {
        return http.get(`/recognition/list-user-device/${idDevice}`)
    }

    /**
     * Lấy danh sách người dùng có trên DB nhưng chưa có trên thiết bị
     * @param idDevice
     */
    getListUsersNoFace(idDevice) {
        return http.get(`/recognition/list-user/no-device/${idDevice}`)
    }

    /**
     * Lấy thông tin thiết bị
     */
    getListDeviceRecognition() {
        return http.get(`/recognition/device`)
    }

    getUserFromDeviceSaveToDB(idDevice) {
        return http.get(`/recognition/save-user/${idDevice}`)
    }

    applyUserFromDevice(idUser, typeAccount, idUserDeviceRecognition) {
        return http.get(`/recognition/apply`, {params: {idUser, typeAccount, idUserDeviceRecognition}})
    }

    deleteUserFromDevice(idUserDeviceRe) {
        return http.delete(`/recognition/delete/user`, {params: {idUserDeviceRe}})
    }

    startSynchronizationJob(data) { return http.post('/recognition/synchronization-jobs', data, { timeout: 15000 }); }
    getSynchronizationJobs() { return http.get('/recognition/synchronization-jobs', { timeout: 15000 }); }
    getSynchronizationJob(id) { return http.get('/recognition/synchronization-jobs/' + encodeURIComponent(id), { timeout: 15000 }); }

    synchronizeFromDeviceToDevice(idDeviceOld, idDeviceNew) {
        return http.get(`/recognition/synchronize`, {params: {idDeviceOld, idDeviceNew}})
    }

    findConfigAttendanceSchool(){
        return http.get(`/recognition/detail/config`)
    }

    updateConfigAttendanceSchool(data) {
        return http.put(`/recognition/update/config`, data)
    }

}

export default new RecognitionManager();